import { useState, useEffect } from 'react'
import Breadcrumb from './Breadcrumb'
import getImageUrl from './get-image-url.js'
import PageHeader from './PageHeader.jsx'
import apiFetch from '@wordpress/api-fetch'
import BtnText from './BtnText'

const postID = document.getElementById('root').getAttribute('data-post-id')

function Thanks(props) {
  const [data, setData] = useState(null)

  useEffect(() => {
    apiFetch({ path: `${import.meta.env.VITE_SITE_URL}/wp-json/wp/v2/pages/${postID}` }).then(
      (posts) => {
        setData(posts)
      }
    )
  }, [])

  return (
    <>
      <PageHeader
        title={props.title ? props.title : 'お問合わせ'}
        image={props.titleImage ? props.titleImage : getImageUrl('CONTACT.png')}
      />
      <div className="content-area">
        <Breadcrumb
          current={props.current ? props.current : 'お問合わせ'}
          site_url={import.meta.env.VITE_SITE_URL}
          items={props.breadcrumb ? props.breadcrumb : []}
        />
      </div>
      <div>
        <h1 className="mt-[114px]">
          {props.thanks ? props.thanks : 'お問い合わせありがとうございます'}
        </h1>
        <p className="paragrah-1 mt-[114px]">
          確認のために、自動返信メールをお送りしております。
          <br />
          万が一、自動返信メールが届かない場合は、
          <br />
          お手数ですがお電話にてお問い合わせください。
        </p>
        <BtnText href={import.meta.env.VITE_SITE_URL}>トップページへ</BtnText>
      </div>
      <style jsx>{`
        h1 {
          text-align: center;
          font: normal normal bold min(calc(50vw / 7.5), 25px) Noto Sans JP;
          color: #2964b6;
        }
        .paragrah-1 {
          text-align: center;
          font: normal normal normal calc(35vw / 7.5) Noto Sans JP;
        }
        .button {
          background: #003475 0% 0% no-repeat padding-box;
          border-radius: 6px;
          width: 335px;
          height: 70px;
          color: #fff;
          margin-left: auto;
          margin-right: auto;
          display: flex;
          text-align: center;
          justify-content: center;
          align-items: center;
          margin-top: 100px;
          position: relative;
          font: normal normal bold 20px/29px Noto Sans JP;
        }
        @media (min-width: 768px) {
          h1 {
            text-align: center;
            font: normal normal bold 80px/80px Noto Sans JP;
            color: #2964b6;
          }
          .paragrah-1 {
            text-align: center;
            font: normal normal normal 30px/60px Noto Sans JP;
          }
          .button {
            background: #003475 0% 0% no-repeat padding-box;
            border-radius: 6px;
            width: 335px;
            height: 70px;
            color: #fff;
            margin-left: auto;
            margin-right: auto;
            display: flex;
            text-align: center;
            justify-content: center;
            align-items: center;
            margin-top: 100px;
            position: relative;
            font: normal normal bold 20px/29px Noto Sans JP;
          }
        }
      `}</style>
    </>
  )
}

export default Thanks
